import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Layout from '../auth/Layout';
import ChangePassword from './ChangePassword';

export default function RequirePasswordChange() {

    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Layout title={t('ChangePassword.RequirePasswordChange')}>
            <ChangePassword onCancel={() => navigate('/logout')} />
        </Layout>
    )
}